import { Subtract } from 'utility-types';
import { MultiSelectRemote, MultiSelectRemoteProps } from '../controls';
import { Field, FieldProps, ControlsCommonProps } from './Field';

export const MultiSelectRemoteField = (props: Subtract<MultiSelectRemoteProps, ControlsCommonProps<number[] | undefined>> & FieldProps) => {
	return (
		<Field
			{...props}
			Control={MultiSelectRemote}
		/>
	)
}
